import type { IconData } from '@stacksjs/iconify-core'

export const borderOut: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M20 21H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1M5 19h14V5H5Z\"/><circle cx=\"12\" cy=\"12\" r=\"1\" fill=\"currentColor\" opacity=\".5\"/><circle cx=\"12\" cy=\"16\" r=\"1\" fill=\"currentColor\" opacity=\".5\"/><circle cx=\"12\" cy=\"8\" r=\"1\" fill=\"currentColor\" opacity=\".5\"/><circle cx=\"8\" cy=\"12\" r=\"1\" fill=\"currentColor\" opacity=\".5\"/><circle cx=\"16\" cy=\"12\" r=\"1\" fill=\"currentColor\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default borderOut
